export default ":host ::ng-deep .mat-form-field {\n  width: 99% !important;\n}"